import axios from "axios";
import authHeader from "./auth-header";
import IRevisionItem from "../types/revision-item.type";


const API_URL = `${process.env.REACT_APP_SERVER_URL}/revision-item`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (revisionItem: IRevisionItem) => {
  return axios.post(API_URL, revisionItem, { headers: authHeader() });
};

export const update = (id: number, revisionItem: IRevisionItem) => {
  return axios.put(API_URL + "/" + id, revisionItem, { headers: authHeader() });
};

export const getRevisionItems = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveRevisionItems = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};
